import React, {useEffect, useState} from "react";
import {GrCheckbox, GrUserAdmin} from "react-icons/gr";
import {FaToggleOn, FaToggleOff, FaUser, FaUserCog, FaUserSecret} from "react-icons/fa";
import Api from "../Api/api";
import {useStateValue} from "../states/StateProvider";
import {toast} from "react-toastify";
import {ClipLoader} from "react-spinners";
import {MdSupervisorAccount} from "react-icons/md";
import UpdateRole from "../components/modal/updateRole";
import {AES, enc} from "crypto-js";

const UserManagementCard = ({email, prtnrNo, valid, userID, name, lastLogin, created, role, users, status, index}) => {
    const [edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loadingName, setLoadingName] = useState(false)
    const [deleteClicked, setDeleteClicked] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const [partnerNr, setPartnerNo] = useState(prtnrNo)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [subRoles, setSubRoles] = useState([])
    const [verified, setVerified] = useState(Number(valid) === 1)
    const [lastSavedVerified, setLastSavedVerified] = useState(Number(valid) === 1)
    const [displayName, setDisplayName] = useState(name)
    const [{userValidated, secretKey}, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const admin = user.isUserAdmin

    function save() {
        setLoading(true)
        let data = new FormData()
        data.append('userID', Number(userID))
        data.append('partnerNo', partnerNr)
        data.append('vorname', firstName)
        data.append('nachname', lastName)
        data.append('verified', verified)
        data.append('email', email) // Add email for activation email

        Api().post('/updateUser', data).then(res => {
            setPartnerNo(res.data[0]?.partnernr)
            setDisplayName(`${lastName}, ${firstName}`)
            const wasInactive = !lastSavedVerified;
            const isNowActive = verified;
            setLastSavedVerified(verified)
            setLoading(false)
            setEdit(false)
            
            // Show appropriate message based on activation status
            if (wasInactive && isNowActive) {
                toast.success('Benutzer erfolgreich aktiviert und E-Mail gesendet')
            } else if (!isNowActive) {
                toast.success('Benutzer auf inaktiv gesetzt')
            } else {
                toast.success('Benutzer erfolgreich aktualisiert')
            }
        }).catch(e => {
            setEdit(false)
            setLoading(false)
            toast.error('Etwas ist schief gelaufen!')
        })
    }

    function cancel() {
        setVerified(lastSavedVerified)
        setEdit(false)
    }

    function removeUser(id) {
        setDeleting(true)
        Api().get(`/deleteUser/${id}`).then(res => {
            dispatch({type: "SET_PAGE", item: 1})
            setEdit(false)
            setDeleting(false)
            toast.success('Benutzer erfolgreich gelöscht')
            dispatch({type: "SET_USER_VALIDATED", item: !userValidated})
        }).catch(e => {
            toast.error('Etwas ist schief gelaufen!')
        })
    }

    function setEditStates(id) {
        setEdit(true)
        let data = new FormData()
        data.append('userID', Number(id))
        setLoadingName(true)
        Api().post('/getName', data).then(res => {
            setFirstName(res.data[0]?.[0]?.firstname)
            setLastName(res.data[0]?.[0]?.lastname)
            setSubRoles(res.data[1]?.[0])
            setLoadingName(false)
        })
    }

    return (
        <tbody
            className={`${status === 'red' && (user.role === 'Internal' || role === 'Controller') ? 'bg-redLight' : status === 'yellow' && (user.role === 'Internal' || role === 'Controller') ? 'bg-yellowLight' : ''}`}>
        <tr className={`${(deleteClicked) && 'overlay'}`}/>
        <tr
            className={`${(!edit || !deleteClicked) && 'hideDiv'} shadow-xl md:w-96 w-11/12 shadow-text text-lg px-6 py-6  flex flex-col rounded-lg z-10 absolute bg-offWhite centerItemsAbsolute`}>
            <td>Wollen Sie den Benutzer ({firstName + ' ' + lastName}) wirklich löschen?</td>
            <td className={`${deleting && 'hideDiv'} flex justify-start px-24 pt-5 text-sm text-md font-bold`}>
                <button onClick={() => removeUser(userID)}
                        className='bg-green mr-3 text-white px-5 hover:bg-white hover:text-green py-2 rounded-xl'>Ja
                </button>
                <button onClick={() => setDeleteClicked(false)}
                        className='bg-cancel hover:bg-white hover:text-cancel text-white px-5 py-2 rounded-xl'>Nein
                </button>
            </td>
            <td className='mx-auto'>
                {deleting && <ClipLoader size={10} color='#3A46A9'/>}
            </td>
        </tr>
        <tr className={`${edit && 'bg-yellowLight'} border-y border-silver border-x-0`} style={{height: '40px', maxHeight: '40px'}}>
            <td hidden={edit} className={`px-6 py-0 whitespace-nowrap text-sm text-gray-900`}>
                    <span className='flex justify-start items-center'>
                             {
                                 role === 'Internal' ?
                                     <GrUserAdmin size={'16px'} color={'#565c8c'}/>
                                     : (role==='ManRUV') ?
                                         <FaUser size={'16px'} color={'#3A46A9'}/>:
                                         (role === 'ManDGG') ?
                                         <FaUser size={'16px'} color={'#0a523f'}/>
                                         : (role === 'ExtRUV') ?
                                             <MdSupervisorAccount size={'16px'} color={'#565c8c'}/>:
                                             (role === 'ExtDGG') ?
                                             <MdSupervisorAccount size={'16px'} color={'#0a523f'}/>
                                             : role && <FaUserSecret size={'16px'} color={'#565c8c'}/>
                             }
                        <span className='ml-2'>{displayName ? displayName : 'N/A'}</span>
                    </span>
            </td>
            <td hidden={!edit}>
                <input className="text-sm text-gray-900 font-light px-3 py-1 whitespace-nowrap mt-1"
                       type='text'
                       placeholder='Nachname'
                       value={lastName}
                       onChange={(e) => setLastName(e.target.value)}
                />
                <input className="text-sm text-gray-900 font-light px-3 py-1 whitespace-nowrap"
                       type='text'
                       placeholder='Vorname'
                       value={firstName}
                       onChange={(e) => setFirstName(e.target.value)}
                />
            </td>
            <td className="text-sm text-gray-900 normal-case font-light px-6 py-0 whitespace-nowrap">
                {email}
            </td>

            <td hidden={edit}
                className="text-sm text-gray-900 font-light px-6 py-0 whitespace-nowrap">
                {prtnrNo}
            </td>
            <td hidden={!edit}>
                <input className="text-sm text-gray-900 font-light px-3 py-1 whitespace-nowrap"
                       type='text'
                       value={partnerNr}
                       onChange={(e) => setPartnerNo(e.target.value)}
                />
            </td>

            <td>
                <button disabled={!edit}
                        onClick={() => setVerified(!verified)}
                        className="text-sm text-gray-900 font-light px-6 py-0 whitespace-nowrap">
                    {
                        verified ?
                            <FaToggleOn color={'#3A46A9'} style={{cursor: edit ? 'pointer' : 'default'}}
                                        size='24px'/>
                            :
                            <FaToggleOff color={'#cccccc'} style={{cursor: edit ? 'pointer' : 'default'}}
                                        size='24px'/>
                    }
                </button>
            </td>
            <td hidden={edit} className="px-6 py-0 whitespace-nowrap text-sm text-gray-900">
                {role === 'Internal' ? 'Innendienst' : role === 'ExtRUV' ? 'FKB' : role === 'ExtDGG' ? 'VP' : role === 'Controller' ? 'Controlling' : role === 'ManRUV' ? 'Management' : role === 'ManDGG' ? 'Struktur' : role}
            </td>
            <td hidden={!edit} className="px-6 py-0 whitespace-nowrap text-sm text-gray-900"></td>
            <td hidden={edit} className="px-6 py-0 whitespace-nowrap text-sm text-gray-900">{created}</td>
            {/*<td hidden={!edit} className="px-6 py-0 whitespace-nowrap text-sm text-gray-900"/>*/}
            <td hidden={edit} className="px-6 py-0 whitespace-nowrap text-sm text-gray-900">{lastLogin}</td>
            {/*<td hidden={!edit} className="px-6 py-2 whitespace-nowrap text-sm text-gray-900"></td>*/}
            <td hidden={!edit} className="text-sm text-gray-900 font-light text-right whitespace-nowrap">
                <UpdateRole userID={userID} role={role} subRoles={subRoles} email={email} isActive={valid}/>
            </td>
            <td hidden={!edit}
                className="text-sm text-gray-900 font-light text-right whitespace-nowrap">
                <button onClick={() => setDeleteClicked(true)}
                        className='border mr-4 border-cancel bg-cancel rounded-3xl px-3 pt-1 pb-1 text-white text-center font-extrabold uppercase cursor-pointer'
                >
                    LÖSCHEN
                </button>
                <button onClick={cancel}
                        className='border border-mainBlue rounded-3xl px-3 pt-1 pb-1 text-mainBlue text-center font-extrabold uppercase cursor-pointer'
                >
                    Abbrechen
                </button>
            </td>
            <td hidden={edit || admin !== '1' || user.role === 'Controller'}
                className="text-sm text-gray-900 font-light px-6 py-0 whitespace-nowrap">
                <button onClick={() => setEditStates(userID)}
                        className='border border-mainBlue rounded-3xl px-3 py-1 text-mainBlue font-extrabold text-xs text-center uppercase cursor-pointer'
                >
                    Bearbeiten
                </button>
            </td>
            <td hidden={!edit}
                className="text-sm text-gray-900 font-light px-6 py-0 whitespace-nowrap">
                <button onClick={save}
                        disabled={loadingName}
                        className={`border border-mainBlue rounded-3xl px-3 py-1 bg-mainBlue ${loadingName && 'bg-grey'} text-white font-extrabold text-xs uppercase cursor-pointer`}
                >
                    {loading ? 'speichere...' : 'Speichern'}
                </button>
            </td>
        </tr>
        </tbody>
    )
}

export default UserManagementCard
